import Vue from 'vue'
import { NETWORKS_CODES } from '@/utils/constants/networks'

export const targetReport = {
    state: {
        status: 'idle',
        targetReport: null,
        pagination: {
            page: 1,
            totalPages: 0,
            perPage: 10,
            totalRecords: null
        },
        availableNetworks: [NETWORKS_CODES.EURO, NETWORKS_CODES.ABC, NETWORKS_CODES.GROSZEK],
        filters: {
            merchantId: {
                type: 'ui-virtual-list',
                value: null,
                multi: false,
                searcher: false,
                label: 'Wybierz sklep',
                moduleName: 'merchants',
                fetchAction: 'merchantsFetch',
                getter: 'getTargetReportLocationsByAvailableNetworks',
                disabledLinkGenerator: true
            }
        }
    },
    mutations: {
        SET_TARGET_REPORT_STATUS(state, payload) {
            state.status = payload
        },
        SET_TARGET_REPORT(state, payload) {
            state.targetReport = payload
        },
        SET_TARGETREPORT_FILTER(state, { filter, value }) {
            Vue.set(state.filters[filter], 'value', value)
        },
        RESET_TARGETREPORT_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        }
    },
    actions: {
        async targetReportFetch({ commit, getters, dispatch }) {
            commit('SET_TARGET_REPORT_STATUS', 'loading')
            const { crmId } = getters.getTargetReportQueryParams

            try {
                if (!crmId) {
                    return
                }

                const { status, data } = await this.$api.get('reports/targetowkaByCrmId/' + crmId)

                if (status !== 200 || !data.data) {
                    throw new Error(data?.message || 'Error GET targetowkaByCrmId')
                }

                commit('SET_TARGET_REPORT', data.data)
            } catch(error) {
                console.log(error)
                commit('SET_TARGET_REPORT', null)
            } finally {
                commit('SET_TARGET_REPORT_STATUS', 'idle')
            }
        },
        setTargetReportDefaultMerchant({ commit, getters }) {
            const merchant = getters.getTargetReportLocationsByAvailableNetworks[0]

            if (merchant) {
                commit('SET_TARGETREPORT_FILTER', {
                    filter: 'merchantId',
                    value: merchant.value
                })
            }
        },
        setTargetReportDefaultCrm({ commit, getters }) {
            const merchant = getters.getAllMerchantCrmsForSelect[0]
            if (merchant) {
                commit('SET_TARGETREPORT_FILTER', {
                    filter: 'merchantId',
                    value: merchant.value
                })
            }
        }
    },
    getters: {
        getTargetReport: state => state.targetReport?.filar_1?.results,
        getTargetReportData: state => {
            return state.targetReport
        },
        getTargetReportStatus: state => {
            return state.status
        },
        getTargetReportSelectedMerchant: state => {
            return state.filters.merchantIds.value
        },
        getTargetReportSelectedCrm: state => {
            return state.filters.merchantId.value
        },
        getTargetReportQueryParams: (state, getters) => {
            return {
                crmId: state.filters.merchantId.value
                    ? getters.getMerchantCrmId(state.filters.merchantId.value)
                    : undefined
            }
        },
        getTargetReportFilters: state => {
            return state.filters
        },
        isAbcNetworkSelected: (state, getters) => {
            const merchantId = state.filters.merchantIds.value
            const merchant = getters.getMerchantById(merchantId)
            const loc = getters.getUserLocationById(merchant.location_id)
            // eslint-disable-next-line camelcase
            return loc?.network_name?.includes('ABC')
        },
        getTargetReportLocationsByAvailableNetworks: (state, getters) => {
            return state.availableNetworks.flatMap(network =>
                getters.getMerchantsByNetworkAlias(network)
            )
        }
    }
}
